import { Injectable } from '@angular/core'
import { Dimensions, ElderToastService, Quantity, Unit } from '@elderbyte/ngx-starter'
import { BehaviorSubject, defaultIfEmpty, map, Observable } from 'rxjs'
import { PackageContentLabelSpec, PackageType } from '../package-type'
import { PackageTypeService } from '../package-type.service'

@Injectable()
export class PackageTypeDetailController {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _packageType$: BehaviorSubject<PackageType> = new BehaviorSubject(null)
  private readonly _creationMode$: Observable<boolean>

  constructor(
    private typeService: PackageTypeService,
    private toastService: ElderToastService
  ) {
    this._creationMode$ = this._packageType$.pipe(
      map((pt) => !pt?.id),
      defaultIfEmpty(false)
    )
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get packageType$(): Observable<PackageType> {
    return this._packageType$.asObservable()
  }

  public get packageType(): PackageType {
    return this._packageType$.getValue()
  }

  public set packageType(type: PackageType) {
    if (!type.defaultMaxWeight) {
      const unit = type.weightUnit ? type.weightUnit : Unit.kg
      type.defaultMaxWeight = Quantity.zero(unit)
    }

    if (!type.defaultMaxDimensions) {
      const unit = type.dimensionUnit ? type.dimensionUnit : Unit.cm
      type.defaultMaxDimensions = Dimensions.zero(unit)
    }

    this._packageType$.next(type)
  }

  public get creationMode$(): Observable<boolean> {
    return this._creationMode$
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public setContentLabelSpecs(specs: PackageContentLabelSpec[]): void {
    this.packageType.labelingSpec.contentLabelSpecs = specs
  }

  public save(): void {
    this.typeService.update(this.packageType).subscribe({
      next: (pkg) => {
        this.packageType = pkg
        this.toastService.info('messages.persisting_successful')
      },
      error: (err) => this.toastService.error('messages.saving_failed', err),
    })
  }

  public delete(): void {
    this.toastService.info('Not supported!')
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private reload(): void {
    this.typeService.findById(this.packageType.id).subscribe((pkg) => (this.packageType = pkg))
  }
}
